import { MapPin } from "lucide-react";
import { COUNTIES } from "@/lib/constants";

export default function ServiceArea() {
    const mo = COUNTIES.filter((c) => c.state === "MO");
    const il = COUNTIES.filter((c) => c.state === "IL");

    return (
        <section
            id="service-area"
            data-testid="service-area-section"
            className="py-24 md:py-32 bg-brand-cream relative overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-12 mb-16">
                    <div className="md:col-span-6">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="w-10 h-px bg-brand-gold" />
                            <span className="text-[10px] tracking-[0.4em] uppercase text-brand-gold-deep">
                                Where We Travel
                            </span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brand-black leading-tight">
                            15 counties.
                            <br />
                            <span className="italic">Two states.</span>
                            <br />
                            One reliable fleet.
                        </h2>
                    </div>
                    <div className="md:col-span-6 md:pt-8">
                        <p className="text-lg text-brand-black/75 leading-relaxed">
                            We serve healthcare facilities, laboratories, pharmacies, and
                            clinics across Missouri and Southern Illinois. Need a route
                            outside our regular service area? With advanced notice, we'll
                            arrange it.
                        </p>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                    <div className="bg-white border border-brand-line p-8 md:p-10">
                        <div className="flex items-baseline justify-between mb-8 pb-4 border-b border-brand-line">
                            <div className="font-serif text-3xl text-brand-black">Missouri</div>
                            <div className="text-[10px] tracking-[0.3em] uppercase text-brand-gold-deep">
                                {mo.length} Counties
                            </div>
                        </div>
                        <ul data-testid="counties-mo" className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                            {mo.map((c) => (
                                <li
                                    key={c.name}
                                    className="flex items-center gap-2 text-brand-black/80 text-base group hover:text-brand-gold-deep transition-colors cursor-default"
                                >
                                    <MapPin size={14} className="text-brand-gold shrink-0" />
                                    {c.name}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="bg-brand-black text-white p-8 md:p-10 relative overflow-hidden">
                        <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-brand-gold/10 blur-3xl" />
                        <div className="relative">
                            <div className="flex items-baseline justify-between mb-8 pb-4 border-b border-white/15">
                                <div className="font-serif text-3xl">Illinois</div>
                                <div className="text-[10px] tracking-[0.3em] uppercase text-brand-gold">
                                    {il.length} Counties
                                </div>
                            </div>
                            <ul data-testid="counties-il" className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                                {il.map((c) => (
                                    <li
                                        key={c.name}
                                        className="flex items-center gap-2 text-white/85 text-base hover:text-brand-gold transition-colors cursor-default"
                                    >
                                        <MapPin size={14} className="text-brand-gold shrink-0" />
                                        {c.name}
                                    </li>
                                ))}
                            </ul>
                            <div className="mt-10 pt-6 border-t border-white/10 text-xs tracking-[0.25em] uppercase text-brand-gold/80">
                                Other counties available with notice
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
